'use client';

var XALOLEAD_ENDPOINT = 'xalolead/v1.0/xalolead';
var SEND_MAIL_ENDPOINT = 'xalolead/v1.0/sendMail';

export { SEND_MAIL_ENDPOINT, XALOLEAD_ENDPOINT };
//# sourceMappingURL=const.js.map
